import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("rect", {
      x: "0.625",
      y: "0.625",
      width: "18.75",
      height: "18.75",
      rx: "1.375",
      fill: "#6E0AFA",
      stroke: "#6E0AFA",
      "stroke-width": "1.25"
    }, null, -1),
    _createElementVNode("path", {
      d: "M8.12499 14.9998C8.0429 14.9999 7.96161 14.9838 7.88577 14.9524C7.80994 14.921 7.74106 14.8749 7.68309 14.8168L3.30809 10.4421C3.25005 10.3841 3.20401 10.3152 3.17259 10.2394C3.14118 10.1636 3.12501 10.0823 3.125 10.0002C3.12499 9.91816 3.14115 9.83689 3.17255 9.76106C3.20396 9.68523 3.24999 9.61632 3.30802 9.55828C3.36605 9.50024 3.43494 9.4542 3.51077 9.42279C3.58659 9.39137 3.66786 9.3752 3.74993 9.37519C3.83201 9.37518 3.91328 9.39134 3.98911 9.42275C4.06494 9.45415 4.13384 9.50018 4.19188 9.55821L8.12499 13.491L16.433 5.18325C16.5503 5.06617 16.7092 5.00043 16.8749 5.00049C17.0406 5.00054 17.1994 5.06638 17.3166 5.18353C17.4338 5.30068 17.4996 5.45956 17.4997 5.62525C17.4997 5.79093 17.434 5.94986 17.317 6.06711L8.56696 14.8168C8.50897 14.8749 8.44007 14.921 8.36423 14.9524C8.28838 14.9838 8.20708 14.9999 8.12499 14.9998V14.9998Z",
      fill: "white",
      stroke: "white",
      "stroke-width": "0.75"
    }, null, -1)
  ])))
}
export default { render: render }